var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.pageLoading)?_c('div',{staticClass:"page-loading"},[_c('div',{staticClass:"loader"},[_c('Sprite',{attrs:{"name":"gear"}})],1)]):_vm._e()]),_c('iframe',{staticClass:"preview-iframe",attrs:{"src":_vm.iframeSrc,"id":"site-previewer-iframe","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }